import http from '../../../Utils/http';

const GetAllAdminUsers = {
  name: 'adminUsers',
  state: {
    data: [],
    loading: false,
    error: '',
    totalCount: 0,
    tableHeader: [
      'Name',
      'Email',
      'Job Title',
    ],
    rpp: 10,
    message: '',
  },
  reducers: {
    getRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
      };
    },

    getReceived(state, payload) {
      const arr = [];
      payload?.data?.forEach((element) => {
        element?.job_title === 'admin' &&
          arr.push({
            id: element?.id,
            name: element?.name ? element.name : "",
            email: element?.email ? element.email : "",
            jobtitle: element?.job_title ? element.job_title : "",
          });
      });
      return {
        ...state,
        data: arr,
        loading: false,
        error: '',
        totalCount: payload.totalCount,
      };
    },

    getRequestFailed(state, payload) {
      return {
        ...state,
        error: payload,
        loading: false,
      };
    },
    deleteUserRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        message: ''
      };
    },
    deleteUserReceived(state, payload) {
      return {
        ...state,
        loading: false,
        message: payload,
        error: '',
      }
    },
    deleteUserRequestFailed(state, payload) {
      return {
        ...state,
        error: payload,
        message: '',
        loading: false,
      };
    },
  },
  effects: (dispatch) => ({
    async getAll({ page, size, sorted_by, sort }) {
      try {
        this.getRequested();
        const params = new URLSearchParams();
        if (sorted_by) params.append('sorted_by', sorted_by);
        if (sort) params.append('sort', sort);
        const qs = params.toString();
        const url = `savvy/users/${size}/${page}/true${qs ? `?${qs}` : ''}`;
        const response = await http.get(url);
        this.getReceived({
          data: response.data.data.rows,
          totalCount: response.data.data?.count,
        });
      } catch (err) {
        this.getRequestFailed(err.message);
      }
    },
    async requestForDeleteUser(id) {
      try {
        this.deleteUserRequested();
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const user_id = userInfo?.id;
        const org_id = userInfo?.org_id;
        const response = await http.delete(`savvy/users/delete/${id}?user_id=${user_id}&org_id=${org_id}`);

        if (response?.data?.success) {
          const successMessage = response?.data?.message || 'User deleted successfully';
          this.deleteUserReceived(successMessage);
        } else {
          const errorMessage = response?.data?.message || response?.data?.error || 'Failed to delete user';
          this.deleteUserRequestFailed(errorMessage);
        }
      } catch (err) {
        const errorMessage = err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          'Unable to delete the user';

        this.deleteUserRequestFailed(errorMessage);
      }
    },
    async clearData() {
      this.deleteUserReceived('');
    }
  }),
};

export default GetAllAdminUsers;